// Import model
import { StartProjectAddNoteRequest } from '../models/StartProjectAddNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAddNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAddNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAddNoteRequest instance
   */
  static deserialize(json: string): StartProjectAddNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAddNoteRequest instance
   */
  static fromObject(obj: any): StartProjectAddNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAddNoteRequest');
    }


    const instance: StartProjectAddNoteRequest = {
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
      content: obj['Content'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAddNoteRequest instances
   */
  static deserializeArray(json: string): StartProjectAddNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAddNoteRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAddNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAddNoteRequest instance to a plain object
   */
  static toObject(instance: StartProjectAddNoteRequest): any {
    return {
      'Name': instance.name,
      'Description': instance.description,
      'Content': instance.content,
    };
  }

  /**
   * Serializes an array of StartProjectAddNoteRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAddNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
